export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen md:h-[90vh] flex flex-col md:flex-row">
      <div className="w-full md:w-[60%] h-[50vh] md:h-auto relative overflow-hidden">
        <img
          src="https://static.readdy.ai/image/5e5e0a5518213db53ed2e7d68521f761/8ecddb4b00941859316c868754176925.jpeg"
          alt="Runner in motion"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
      </div>

      <div className="w-full md:w-[40%] bg-[#FAFAF8] flex items-center">
        <div className="px-6 py-12 md:pl-[8%] md:pr-[6%]">
          <div className="uppercase text-xs font-semibold tracking-[0.2em] text-gray-600 mb-4">
            PACED COACHING
          </div>
          
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight font-serif">
            Online Running Coaching — <span className="text-[#E8744F]">$50/month</span>
          </h1>
          
          <p className="text-base md:text-lg text-gray-600 mb-10 leading-relaxed">
            Personalized training plans for runners who want to improve without burnout.
          </p>
          
          <a
            href="https://calendar.app.google/fm26XKpqmgC8oisS7"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-8 py-4 bg-[#2B2B2B] text-white font-semibold rounded-full hover:bg-[#1a1a1a] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Book your Free 30-minute Consult!
          </a>
        </div>
      </div>
    </section>
  );
}
